import WeekDaySelector from './WeekDaySelector.form'

export default WeekDaySelector
